export default __webpack_public_path__ + "static/media/hero_img.970a4fae.png";